import { actionTypeCreator, SYNC } from 'lib/redux-utils';
import { NAME } from './constants';

const namespace = actionTypeCreator(NAME);

export const T = namespace(['PLAY_SOUND', 'LOAD_SPRITE', 'CAN_LOAD_SPRITE'] as const, SYNC);
